import { Box, Icon, Paper, Typography } from "@mui/material";
import { PrizaMenuOptions } from "./PrizaMenu";

export interface PrizaLandingProps {
    options: PrizaMenuOptions[];
    itself?: string;
}

const PrizaLanding = ({ options, itself }: PrizaLandingProps) => {
    return (
        <Paper elevation={0} sx={{ p: 2 }}>
            <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                {options
                    .filter((option) => option.option !== itself)
                    .map((option) => {
                        const color = option.disabled == true ? "grey" : `${option.color || "primary"}.main`;
                        const hoover = option.color || "primary";
                        return (
                            <Paper key={option.option} 
                                elevation={10}
                                onClick={() => {
                                    if (option.disabled == true) {
                                        return;
                                    }
                                    option.onClick(option.option);
                                }}
                                sx={{ 
                                    padding: 2, margin: 2, width: "200px", height: "120px",
                                    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                                    cursor: "pointer",
                                    "&:hover": { 
                                        backgroundColor: option.disabled == true ? undefined : `${hoover}.contrastText`, 
                                        color: option.disabled == true ? undefined : `${hoover}.main`
                                    }
                                }}
                            >
                                <Icon sx={{ transform: "scale(2)", mb: 3, color: color}}>
                                    {option.icon}
                                </Icon>
                                <Typography variant="body1" sx={{ color: color }}>{option.tooltip}</Typography>
                            </Paper>
                        );
                    }
                )}
            </Box>
        </Paper>
    );
};

export default PrizaLanding;